<template>
  <div ref="captchaDiv" />
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import RecaptchaHelper from '@/App/Utils/recaptchaHelper';
import logger from '@/App/Utils/logger';

const props = defineProps<{
    publicKey: string,
    languageCode: string,
}>();

const emit = defineEmits([
  'captcha-verified',
  'captcha-expired']);

const recaptchaValue = ref<string | null>(null);

const captchaDiv = ref<HTMLElement | null>(null);

onMounted(() => {
  const options = {
    'sitekey': props.publicKey,
    'hl': props.languageCode,
    'callback': function (captchaValue) {
      recaptchaValue.value = captchaValue;
      emit('captcha-verified', captchaValue);
    },
    'expired-callback': function () {
      recaptchaValue.value = null;
      emit('captcha-expired');
    }
  };


  RecaptchaHelper.getRecaptcha().then(recaptcha => {
    recaptcha.render((<HTMLElement>captchaDiv.value), options);
  })
      .catch(ex => {
        logger.error('CaptchaUnavailable', ex);
      });
});
</script>
